import { BASE_API_URL } from "./Common";
import { authHeader, authRequestConfig } from "./AuthService";
import { getAuthCookieSessionsEnabled } from '../components/auth/googleAuthConfig';
import { consumeSseResponse } from './agentEventStream';

import axios from 'axios';

const authApiConfig = (config = {}) => authRequestConfig({
    ...config,
    headers: {
        ...authHeader(),
        ...(config.headers || {}),
    },
});

const authAxios = {
    get: (url, config) => axios.get(url, authApiConfig(config)),
    post: (url, data, config) => axios.post(url, data, authApiConfig(config)),
    put: (url, data, config) => axios.put(url, data, authApiConfig(config)),
    delete: (url, config) => axios.delete(url, authApiConfig(config)),
};

const DataService = {
    Init: function () {
        // Any application initialization logic comes here
    },
    GetSolutions: async function (return_count, sort_by, search, equation_types,
        problem_types, condition_types, equation_ids, use_case_ids, domain_t_min, domain_t_max, domain_x_min, domain_x_max, domain_y_min, domain_y_max) {
        let url = "/solutions";
        if (return_count) {
            url += "?return_count=true";
        } else {
            url += "?return_count=false";
        }
        if (sort_by) {
            url += "&sort_by=" + sort_by;
        }
        if (equation_types) {
            url += "&equation_types=" + equation_types;
        }
        if (problem_types) {
            url += "&problem_types=" + problem_types;
        }
        if (condition_types) {
            url += "&condition_types=" + condition_types;
        }
        if (equation_ids) {
            url += "&equations=" + equation_ids;
        }
        if (use_case_ids) {
            url += "&use_cases=" + use_case_ids;
        }
        if (search && search != '') {
            url += "&q=" + search;
        }
        if (domain_t_min) {
            url += "&domain_t_min=" + domain_t_min;
        }
        if (domain_t_max) {
            url += "&domain_t_max=" + domain_t_max;
        }
        if (domain_x_min) {
            url += "&domain_x_min=" + domain_x_min;
        }
        if (domain_x_max) {
            url += "&domain_x_max=" + domain_x_max;
        }
        if (domain_y_min) {
            url += "&domain_y_min=" + domain_y_min;
        }
        if (domain_y_max) {
            url += "&domain_y_max=" + domain_y_max;
        }
        return await authAxios.get(BASE_API_URL + url);
    },
    GetFeaturedSolutions: async function () {
        return await authAxios.get(BASE_API_URL + "/solutions?featured=true");
    },
    GetUserSolutions: async function (username) {
        return await authAxios.get(BASE_API_URL + "/solutions?username=" + username);
    },
    GetMySolutions: async function () {
        return await authAxios.get(BASE_API_URL + "/solutions?my=true");
    },
    GetSubmittedSolutions: async function () {
        return await authAxios.get(BASE_API_URL + "/solutions?status=submitted");
    },
    GetPublishedSolutions: async function () {
        return await authAxios.get(BASE_API_URL + "/solutions?status=published");
    },
    GetSolution: async function (id) {
        return await authAxios.get(BASE_API_URL + "/solutions/" + id, { headers: authHeader() });
    },
    GetSolutionVersions: async function (id) {
        return await authAxios.get(BASE_API_URL + "/solutions/versions?id=" + id, { headers: authHeader() });
    },
    CheckSolutionAccess: async function (id) {
        return await authAxios.get(BASE_API_URL + "/solutions/access/" + id, { headers: authHeader() });
    },
    UpdateSolution: async function (id, solution) {
        return await authAxios.put(BASE_API_URL + "/solutions/" + id, solution, { headers: authHeader() });
    },
    SubmitSolution: async function (id, comment) {
        return await authAxios.put(BASE_API_URL + "/solutions/" + id + "/submit", { "comment": comment }, { headers: authHeader() });
    },
    PublishSolution: async function (id, comment) {
        return await authAxios.put(BASE_API_URL + "/solutions/" + id + "/publish", { "comment": comment }, { headers: authHeader() });
    },
    RejectSolution: async function (id, comment) {
        return await authAxios.put(BASE_API_URL + "/solutions/" + id + "/reject", { "comment": comment }, { headers: authHeader() });
    },
    DeleteSolution: async function (id) {
        return await authAxios.delete(BASE_API_URL + "/solutions/" + id, { headers: authHeader() });
    },
    GetTopContributors: async function () {
        return await authAxios.get(BASE_API_URL + "/solutions/top_contributors", { headers: authHeader() });
    },
    GetHubStatusHistory: async function (id) {
        return await authAxios.get(BASE_API_URL + "/solutions/hub_status_history?id=" + id, { headers: authHeader() });
    },
    GetUseCases: async function () {
        return await authAxios.get(BASE_API_URL + "/use_cases", { headers: authHeader() });
    },
    GetUseCase: async function (id) {
        return await authAxios.get(BASE_API_URL + "/use_cases/" + id, { headers: authHeader() });
    },
    CreateUseCase: async function (use_case) {
        return await authAxios.post(BASE_API_URL + "/use_cases", use_case, { headers: authHeader() });
    },
    UpdateUseCase: async function (use_case) {
        return await authAxios.put(BASE_API_URL + "/use_cases", use_case, { headers: authHeader() });
    },
    GetEquations: async function () {
        return await authAxios.get(BASE_API_URL + "/equations", { headers: authHeader() });
    },
    GetEquation: async function (id) {
        return await authAxios.get(BASE_API_URL + "/equations/" + id, { headers: authHeader() });
    },
    CreateEquation: async function (equation) {
        return await authAxios.post(BASE_API_URL + "/equations", equation, { headers: authHeader() });
    },
    UpdateEquation: async function (equation) {
        return await authAxios.put(BASE_API_URL + "/equations", equation, { headers: authHeader() });
    },
    GetUserProfile: async function (username) {
        return await authAxios.get(BASE_API_URL + "/profile/" + username, { headers: authHeader() });
    },
    GetUserInfo: async function (user_id) {
        return await authAxios.get(BASE_API_URL + "/userinfo?id=" + user_id, { headers: authHeader() });
    },
    GetProjects: async function () {
        return await authAxios.get(BASE_API_URL + "/projects", { headers: authHeader() });
    },
    CreateProject: async function (project) {
        return await authAxios.post(BASE_API_URL + "/projects", project, { headers: authHeader() });
    },
    UpdateProject: async function (id, project) {
        return await authAxios.put(BASE_API_URL + "/projects/" + id, project, { headers: authHeader() });
    },
    GetProject: async function (id) {
        return await authAxios.get(BASE_API_URL + "/projects/" + id, { headers: authHeader() });
    },
    DeleteProject: async function (id) {
        return await authAxios.delete(BASE_API_URL + "/projects/" + id, { headers: authHeader() });
    },
    DeleteProjectUser: async function (user_name, projectid) {
        return await authAxios.put(BASE_API_URL + "/projects/remove_users/" + user_name, projectid, { headers: authHeader() });
    },
    UpdateProjectUser: async function (user_name, project) {
        return await authAxios.put(BASE_API_URL + "/projects/update_users/" + user_name, project, { headers: authHeader() });
    },

    CheckProjectAccess: async function (projectname) {
        return await authAxios.get(BASE_API_URL + "/projects/check_access/" + projectname, { headers: authHeader() });
    },
    NotifyProjectChange: async function (project_notify) {
        return await authAxios.post(BASE_API_URL + "/projects/notification", project_notify, { headers: authHeader() });
    },
    NotifyProjectDetails: async function (project_details) {
        return await authAxios.post(BASE_API_URL + "/projects/details_notification", project_details, { headers: authHeader() });
    },
    SearchProjects: async function (q) {
        return await authAxios.get(BASE_API_URL + "/projects?q=" + q, { headers: authHeader() });
    },
    SearchUsers: async function (q) {
        return await authAxios.get(BASE_API_URL + "/users?q=" + q, { headers: authHeader() });
    },
    GetUsers: async function (pageNumber = 0, pageSize = 100) {
        return await authAxios.get(
            BASE_API_URL + `/users?page_num=${pageNumber}&page_size=${pageSize}`,
            { headers: authHeader() }
        );
    },
    GetUserAccessPlans: async function () {
        return await authAxios.get(BASE_API_URL + "/users/access-plans", { headers: authHeader() });
    },
    UpdateUserAccess: async function (userId, payload) {
        return await authAxios.put(
            BASE_API_URL + `/users/${userId}/access`,
            payload,
            { headers: authHeader() }
        );
    },
    SendAgentMessage: async function (messages) {
        return await authAxios.post(BASE_API_URL + "/agent/chat", { messages: messages }, { headers: authHeader() });
    },
    CreateAgentConversation: async function (title = "PINNs Agent workflow", idempotencyKey) {
        return await authAxios.post(
            BASE_API_URL + "/agent/v2/conversations",
            { title: title },
            { headers: { ...authHeader(), 'Idempotency-Key': idempotencyKey } }
        );
    },
    GetAgentConversation: async function (conversationId) {
        return await authAxios.get(
            BASE_API_URL + "/agent/v2/conversations/" + encodeURIComponent(conversationId),
            { headers: authHeader() },
        );
    },
    ExportAgentConversation: async function (conversationId) {
        return await authAxios.get(
            BASE_API_URL + "/agent/v2/conversations/" + encodeURIComponent(conversationId) + "/export",
            { headers: authHeader() },
        );
    },
    DeleteAgentConversation: async function (conversationId) {
        return await authAxios.delete(
            BASE_API_URL + "/agent/v2/conversations/" + encodeURIComponent(conversationId),
            {
                headers: {
                    ...authHeader(),
                    'X-Confirm-Conversation-Deletion': 'true',
                },
            },
        );
    },
    CreateAgentPlan: async function (conversationId, requirements, uploads = [], idempotencyKey) {
        return await authAxios.post(
            BASE_API_URL + "/agent/v2/plans",
            { conversation_id: conversationId, requirements: { text: requirements, uploads: uploads } },
            { headers: { ...authHeader(), 'Idempotency-Key': idempotencyKey } }
        );
    },
    UploadAgentFile: async function (file, idempotencyKey, onUploadProgress) {
        const formData = new FormData();
        formData.append('file', file);
        return await authAxios.post(BASE_API_URL + "/agent/v2/uploads", formData, {
            headers: { ...authHeader(), 'Idempotency-Key': idempotencyKey },
            onUploadProgress: onUploadProgress,
        });
    },
    ListAgentFiles: async function (search = '') {
        return await authAxios.get(BASE_API_URL + "/agent/v2/uploads", {
            headers: authHeader(),
            params: search ? { search } : undefined,
        });
    },
    GetAgentWorkspace: async function (workspaceId) {
        return await authAxios.get(
            BASE_API_URL + "/agent/v2/workspaces/" + encodeURIComponent(workspaceId),
            { headers: authHeader() },
        );
    },
    CreateAgentWorkspace: async function (planId, files, roles, provenance, idempotencyKey) {
        return await authAxios.post(
            BASE_API_URL + "/agent/v2/plans/" + encodeURIComponent(planId) + "/workspace",
            { files, roles, provenance },
            { headers: { ...authHeader(), 'Idempotency-Key': idempotencyKey } },
        );
    },
    CreateAgentTemplateWorkspace: async function (planId, templateId, idempotencyKey) {
        return await authAxios.post(
            BASE_API_URL + "/agent/v2/plans/" + encodeURIComponent(planId) + "/template-workspace",
            { template_id: templateId },
            { headers: { ...authHeader(), 'Idempotency-Key': idempotencyKey } },
        );
    },
    ValidateAgentWorkspace: async function (workspaceId) {
        return await authAxios.post(
            BASE_API_URL + "/agent/v2/workspaces/" + encodeURIComponent(workspaceId) + "/validate",
            {},
            { headers: authHeader() },
        );
    },
    DownloadAgentFile: async function (uploadId) {
        return await authAxios.get(BASE_API_URL + "/agent/v2/uploads/" + uploadId, {
            headers: authHeader(),
            responseType: 'blob',
        });
    },
    ApproveAgentPlan: async function (planId, payload, idempotencyKey) {
        return await authAxios.post(BASE_API_URL + "/agent/v2/plans/" + planId + "/approve", payload, {
            headers: { ...authHeader(), 'Idempotency-Key': idempotencyKey },
        });
    },
    CreateAgentRun: async function (payload) {
        return await authAxios.post(BASE_API_URL + "/agent/v2/runs", payload, { headers: authHeader() });
    },
    GetAgentRun: async function (runId) {
        return await authAxios.get(BASE_API_URL + "/agent/v2/runs/" + runId, { headers: authHeader() });
    },
    GetAgentRunResult: async function (runId) {
        return await authAxios.get(
            BASE_API_URL + "/agent/v2/runs/" + encodeURIComponent(runId) + "/result",
            { headers: authHeader() },
        );
    },
    GetAgentRunEvents: async function (runId, afterSequence = 0) {
        return await authAxios.get(BASE_API_URL + "/agent/v2/runs/" + runId + "/events", {
            headers: authHeader(),
            params: { after_sequence: afterSequence, limit: 200 },
        });
    },
    StreamAgentRunEvents: async function (runId, afterSequence = 0, onEvent, signal) {
        const response = await fetch(
            BASE_API_URL + "/agent/v2/runs/" + encodeURIComponent(runId) + "/events/stream?after_sequence="
                + encodeURIComponent(afterSequence),
            {
                headers: { ...authHeader(), Accept: 'text/event-stream' },
                credentials: getAuthCookieSessionsEnabled() ? 'include' : 'same-origin',
                signal,
            },
        );
        if (!response.ok) {
            const error = new Error('The event stream request failed.');
            error.status = response.status;
            throw error;
        }
        await consumeSseResponse(response, (frame) => {
            if (frame.event === 'run_event' && frame.data && typeof onEvent === 'function') {
                onEvent(frame.data);
            }
        });
    },
    GetAgentArtifacts: async function (runId) {
        return await authAxios.get(BASE_API_URL + "/agent/v2/runs/" + encodeURIComponent(runId) + "/artifacts", {
            headers: authHeader(),
        });
    },
    DownloadAgentArtifact: async function (runId, artifactId) {
        return await authAxios.get(
            BASE_API_URL + "/agent/v2/runs/" + encodeURIComponent(runId) + "/artifacts/" + encodeURIComponent(artifactId),
            { headers: authHeader(), responseType: 'blob' },
        );
    },
    CancelAgentRun: async function (runId, idempotencyKey) {
        return await authAxios.post(BASE_API_URL + "/agent/v2/runs/" + runId + "/cancel", {}, {
            headers: { ...authHeader(), 'Idempotency-Key': idempotencyKey },
        });
    },
    RefreshAgentKnowledge: async function () {
        return await authAxios.post(BASE_API_URL + "/agent/refresh", {}, { headers: authHeader() });
    },
}

export default DataService;
